import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Locale, DEFAULT_LOCALE } from '@packages/global';

interface LanguageState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      locale: DEFAULT_LOCALE,
      setLocale: (locale) => {
        set({ locale });
        // 懒加载避免循环依赖（i18n 模块顶层执行 .init()）
        import('../i18n').then(({ default: i18n }) => {
          i18n.changeLanguage(locale);
        });
      },
    }),
    { name: 'language-storage' }
  )
);
